import { ShieldCheck, Truck } from 'lucide-react';
import { Link } from 'react-router-dom';
import { cn } from '@/lib/utils';

export const PurchaseBenefits = ({ className }: { className?: string }) => (
  <p className={cn('mt-3 flex flex-wrap items-center gap-x-2 gap-y-1 text-sm leading-snug text-v2-muted', className)}>
    <span className="inline-flex items-center gap-1">
      <Truck className="h-3.5 w-3.5 shrink-0" aria-hidden />
      Frete grátis para todo o Brasil
    </span>
    <span aria-hidden>·</span>
    <Link to="/garantia" className="relative z-20 inline-flex items-center gap-1 underline underline-offset-2 hover:text-v2-ink">
      <ShieldCheck className="h-3.5 w-3.5 shrink-0" aria-hidden />
      Devolvemos 100% em 7 dias
    </Link>
  </p>
);
